module.exports = __webpack_public_path__ + "img/Banner-slide-2.bd7d7398.jpg";